import { memo } from 'react';
import BarChartVertical from '@components/BarChartVertical';
import { useTheme } from '@simplywallst/ui-core';

interface Props {
  portfolioName: string;
  marketName: string;
  expectedAnnualEarningsGrowthRate: number;
  pastAverageEarningsGrowthRate: number;
  marketEarningsGrowthRate: number;
  expectedRevenueGrowthRate: number;
  pastAverageRevenueGrowthRate: number;
  marketRevenueGrowthRate: number;
  expectedAnnualEarningsGrowthRateFormatted: string;
  pastAverageEarningsGrowthRateFormatted: string;
  marketEarningsGrowthRateFormatted: string;
  expectedRevenueGrowthRateFormatted: string;
  pastAverageRevenueGrowthRateFormatted: string;
  marketRevenueGrowthRateFormatted: string;
}

const charts = ['earnings growth', 'revenue growth'];

const keys = ['future average', 'past average', 'market average'];

const FutureAnnualGrowthAnalysis = ({
  marketName,
  portfolioName,
  expectedAnnualEarningsGrowthRate,
  pastAverageEarningsGrowthRate,
  marketEarningsGrowthRate,
  expectedRevenueGrowthRate,
  pastAverageRevenueGrowthRate,
  marketRevenueGrowthRate,
  expectedAnnualEarningsGrowthRateFormatted,
  pastAverageEarningsGrowthRateFormatted,
  marketEarningsGrowthRateFormatted,
  expectedRevenueGrowthRateFormatted,
  pastAverageRevenueGrowthRateFormatted,
  marketRevenueGrowthRateFormatted,
}: Props) => {
  const theme = useTheme();

  const entities = {
    [charts[0]]: {
      [keys[0]]: expectedAnnualEarningsGrowthRate,
      [keys[1]]: pastAverageEarningsGrowthRate,
      [keys[2]]: marketEarningsGrowthRate,
    },
    [charts[1]]: {
      [keys[0]]: expectedRevenueGrowthRate,
      [keys[1]]: pastAverageRevenueGrowthRate,
      [keys[2]]: marketRevenueGrowthRate,
    },
  };

  const entitiesFormatted = {
    [charts[0]]: {
      [keys[0]]: expectedAnnualEarningsGrowthRateFormatted,
      [keys[1]]: pastAverageEarningsGrowthRateFormatted,
      [keys[2]]: marketEarningsGrowthRateFormatted,
    },
    [charts[1]]: {
      [keys[0]]: expectedRevenueGrowthRateFormatted,
      [keys[1]]: pastAverageRevenueGrowthRateFormatted,
      [keys[2]]: marketRevenueGrowthRateFormatted,
    },
  };

  const entityTooltips = {
    [charts[0]]: {
      [keys[0]]: portfolioName,
      [keys[1]]: portfolioName,
      [keys[2]]: marketName,
    },
    [charts[1]]: {
      [keys[0]]: portfolioName,
      [keys[1]]: portfolioName,
      [keys[2]]: marketName,
    },
  };

  return (
    <BarChartVertical
      charts={charts}
      entities={entities}
      entitiesFormatted={entitiesFormatted}
      entityTooltips={entityTooltips}
      keys={keys}
      colors={theme.chart.barChart.futureAnnualGrowthAnalysis.colors}
      titleColors={theme.chart.barChart.futureAnnualGrowthAnalysis.titleColors}
      height={250}
    />
  );
};

export default memo(FutureAnnualGrowthAnalysis);
